import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthService } from '@auth0/auth0-angular'
import { clearAuthStorage } from '@utils/storage.utils'
import { catchError, throwError } from 'rxjs'

export const authErrorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService)

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        console.warn('Authentication error detected, redirecting to login...')
        clearAuthStorage()
        auth.loginWithRedirect()
      }
      return throwError(() => error)
    })
  )
}
